// extracted by mini-css-extract-plugin
module.exports = {"sectionHero":"SectionHero_sectionHero__S_IQy","title":"SectionHero_title__DPRJG","image":"SectionHero_image__HoQ98","text":"SectionHero_text__MCzxB"};